import Box from "@mui/material/Box";
import * as theme from '../../../theme';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import CostContext, { formatCentsToDollars } from "../../../contexts/CostContext";

export default function ReviewEnroll({ formData, cardDetails, discount }) {
  const subscriptionAmount = CostContext.SubscriptionAmount;
  const effectiveAmount = Math.max(0, subscriptionAmount - discount);

  return (
    <Box sx={{ ...theme.FullForm.form, gap: 2 }}>
      <Typography><strong>Email:</strong> {formData.email}</Typography>
      <Typography><strong>Name:</strong> {formData.firstName} {formData.lastName}</Typography>
      <Typography><strong>Phone:</strong> {formData.phone}</Typography>
      <Typography><strong>Date of Birth:</strong> {formData.dob ? dayjs(formData.dob).format('MMMM D, YYYY') : 'N/A'}</Typography>
      <Typography><strong>Business Name:</strong> {formData.businessName || 'N/A'}</Typography>
      <Typography><strong>Address:</strong> {formData.street}{formData.address2 ? `, ${formData.address2}` : ''}, {formData.city}, {formData.state} {formData.zip}</Typography>
      <Typography><strong>Payment:</strong> Card ending in {cardDetails?.last4 || 'XXXX'} ({cardDetails?.brand || 'N/A'})</Typography>
      {discount > 0 && (
        <>
          <Typography><strong>Original Price:</strong> ${formatCentsToDollars(subscriptionAmount)} for subscription</Typography>
          <Typography><strong>Discount:</strong> -${formatCentsToDollars(discount)}</Typography>
          <Typography><strong>Total:</strong> ${formatCentsToDollars(effectiveAmount)}</Typography>
        </>
      )}
      {!discount && (
        <Typography><strong>Total:</strong> ${formatCentsToDollars(subscriptionAmount)} for subscription</Typography>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        By clicking Enroll & Charge Card, you agree to the terms and authorize the charge.
      </Typography>
    </Box>
  );
}